module.exports = __webpack_public_path__ + "img/电压.d367a08e.png";